import { format, type FormatOptions } from 'date-fns';
import { ptBR } from 'date-fns/locale';

type DateInput = string | Date | null | undefined;

export function safeFormatDate(
  input: DateInput,
  pattern: string,
  opts: FormatOptions = { locale: ptBR },
): string {
  const d = toDate(input);
  return d ? format(d, pattern, opts) : '';
}

export function parseLocalDate(value: string | null | undefined): Date | null {
  if (!value || !/^\d{4}-\d{2}-\d{2}/.test(value)) return null;
  const [y, m, d] = value.substring(0, 10).split('-').map(Number);
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return null;
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return null;
  return date;
}

export function isValidDateInput(input: DateInput): boolean {
  return toDate(input) !== null;
}

/** Chave civil dos dez primeiros caracteres. Não interpreta o restante como instante. */
export function civilDateKey(value: string | null | undefined): string {
  if (!value || !/^\d{4}-\d{2}-\d{2}/.test(value)) return '';
  return value.slice(0, 10);
}

/** Apresentação de data civil. O dia não muda com o fuso do navegador. */
export function formatCivilDate(value: string | null | undefined, pattern = 'dd/MM/yyyy'): string {
  const date = parseLocalDate(civilDateKey(value));
  return date ? format(date, pattern, { locale: ptBR }) : '';
}

function toDate(input: DateInput): Date | null {
  if (input == null || input === '') return null;
  if (input instanceof Date) return Number.isNaN(input.getTime()) ? null : input;
  if (typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input)) return parseLocalDate(input);
  const d = new Date(input);
  return Number.isNaN(d.getTime()) ? null : d;
}
